import React from 'react'

import { Svg, SvgProps } from '../Svg'
import { Box } from '../Box'
import graphics from './graphics'

export interface GraphicProps extends SvgProps {
  name: string
}

export const Graphic = ({ name, ...restProps }: GraphicProps) => {
  const path = graphics[name]?.path
  const viewBox = graphics[name]?.viewBox

  if (!path) return <Box bg="gray.200" {...restProps} />

  return (
    <Svg viewBox={viewBox} {...restProps}>
      {path}
    </Svg>
  )
}

export default Graphic
